import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { MenuCategory, MenuCategoryType } from "@shared/types/graphqlGenerated";

const MegaMenu_ClinicShared_Query = gql`
  query MegaMenu_ClinicShared_Query($kind: MenuCategoryType!) {
    viewer {
      menuCategories(kind: $kind) {
        id
        name
        subCategories {
          id
          name
          isHighlighted
          items {
            name
            filterType
            id
            targetUrl
          }
        }
      }
    }
  }
`;

interface MegaMenuData {
  viewer: {
    menuCategories: MenuCategory[];
  };
}

interface Variables {
  kind: MenuCategoryType;
}

const useMegaMenuQuery = (options?: QueryHookOptions<MegaMenuData, Variables>) => {
  return useQuery<MegaMenuData, Variables>(MegaMenu_ClinicShared_Query, options);
};

export type { MegaMenuData, Variables };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useMegaMenuQuery, MegaMenu_ClinicShared_Query };
